import React, { /*Fragment, useContext,*/ useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
//import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import classNames from 'classnames';
//import { LocalesContext } from '../index';
import {
  addProductToCart,
  removeProductFromCart,
  replaceProductInCart,
  setCartRefundable,
} from '../reducers/cart';
import {
  PROGRAM_TYPES,
  selectCampOption,
  deselectCampOption,
  resetSelectedOptions,
  setProgramType,
  setProgramPeriod,
  resetBundleOptions,
  //resetConcentrationOptions,
  setRefundable,
  setBoarding,
  selectConcentrationOption,
  deselectConcentrationOption,
  setLocked,
  setConcentrationDataLength,
  setSkipConcentrations,
} from '../reducers/form';
import API from '../utils/api';
import GTMService, { TYPES } from '../utils/gtm';
//import { formatPrice, getIsAdult } from '../utils/helpers';

import { isSameDay, isWithinInterval, subDays, addDays } from 'date-fns';
import { DayPicker } from 'react-day-picker';
import SpecializationItem from './specializations/SpecializationItem';

const api = new API();
const gtm = new GTMService();

//const LIMIT = 40;

const serializeCamp = (camp) => ({
  id: camp.id,
  name: `${camp.name}`,
  hasExcursions: camp.is_bundle_excursion,
  hasGears: camp.is_bundle_gear,
  hasEssentials: camp.is_bundle_laundry,
  gearsAmount: camp.is_bundle_gear_amount,
  essentialsAmount: camp.is_bundle_laundry_amount,
  excursionsAmount: camp.is_bundle_excursion_amount,
  hasConcentrationWeeks: camp.display_concentration_step,
  startDate: camp.start_date,
  endDate: camp.end_date,
  programLength: camp.program_length,
});

const StepTwo = ({
  initialDate,
  initialSecondaryGroup,
  sport,
  businessType,
  boarding,
  gender,
  position,
  mainPosition,
  age,
  selectedCampOptions,
  programType,
  programLengthInWeeks,
  programLengthInDays,
  forcedRefundable,
  addProductToCart,
  removeProductFromCart,
  replaceProductInCart,
  selectCampOption,
  deselectCampOption,
  resetSelectedOptions,
  resetOptions,
  setProgramType,
  setProgramPeriod,
  defaultRefundable,
  setCartRefundable,
  refundable,
  setBoarding,
  selectConcentrationOption,
  deselectConcentrationOption,
  selectedConcentrationOptions,
  locked,
  setLocked,
  setConcentrationDataLength,
  setSkipConcentrations,
}) => {
  //const locales = useContext(LocalesContext);
  //const [camps, setCamps] = useState(null);
  //const [yearMonthIndexes, setYearMonthIndexes] = useState(null);
  //const [programs, setPrograms] = useState(null);
  //const [tabIndex, setTabIndex] = useState(0);
  //const [limit, setLimit] = useState(LIMIT);
  //const isAdult = getIsAdult(age);

  console.log('Status boarding:',boarding);
  console.log('Status refundable:',refundable);
  console.log('Status sport:',sport);
  console.log('Status age:',age);
  console.log('Status gender:',gender);
  console.log('Status businessType:',businessType);
  console.log('Status programLengthInWeeks:', programLengthInWeeks);
  console.log('Status mainPosition:', mainPosition);

  /* NoData */
  const [noData, setNoData] = useState(false);
  const [calendarLocked, setCalendarLocked] = useState(false);

  /* Histogram */
  const [filterLength, setFilterLength] = useState([]);
  const [selectedLength, setSelectedLength] = useState(null);
  const [filterPriceTypes, setFilterPriceTypes] = useState([]);
  console.log('filterLength:',filterLength);
  console.log('selectedLength:',selectedLength);
  console.log('filterPriceTypes:',filterPriceTypes);
  useEffect(() => {
    if (!sport || !age || !gender || !businessType) {
      return;
    }
    //setLimit(LIMIT);
    api
      .fetchCalendarFilter({
        age,
        gender,
        sport,
        business_type: businessType,
      })
      .then((res) => {
        if (!res) {
          return;
        }
        console.log('fetchCalendarFilter', res);
        var options = [];
        var option_item = {};
        if (res.results.camp_type_options && res.results.camp_type_options.length) {
          var isPresentLength = null;
          var oneWeekPresent = false;
          for (let items of res.results.camp_type_options) {
            option_item = {};
            option_item.value = items;
            option_item.label = items;
            options.push(option_item);
            if(selectedLength && selectedLength === items) {
              isPresentLength = items;
            }
            if(option_item.value === '1-Week Camps'){
              oneWeekPresent = true;
            }
          }
          if(options.length) {
            setFilterLength(options);
            if(!isPresentLength){
              if(oneWeekPresent){
                setSelectedLength('1-Week Camps');
              } else {
                setSelectedLength(options[0].value);
              }
            }
          }
        }
        if (res.results.price_types && res.results.price_types.length) {
          options = [];
          for (let items of res.results.price_types) {
            option_item = {};
            option_item.value = items;
            option_item.label = items;
            options.push(option_item);
          }
          if(options.length) {
            setFilterPriceTypes(options);
          }
        }
      });
  }, [boarding, age, gender, sport, businessType, selectedLength]);

  /* Filter */
  const filtersWrapper = (
    <div className="filters-wrapper">
      {window.locked &&
        <div class="locked"></div>
      }
      <h4 className="field__title">Filter by:</h4>
      <div className="filters-inner">

        <div className="filters-inner-filter">
          <div className="field__title">
            {businessType === 'Adult Program'
              ? 'Stay at the Legacy Hotel at IMG Academy'
              : 'Housing'}
          </div>
          <label className={classNames('field__label')}>
            <select
              name={`filters-housing`}
              onChange={(e) => {
                const value = e.target.value;
                // Clear calendar selections if change filter
                setSelectedDay([]);
                setRangeData([]);
                setRanges([]);
                // End Clear calendar selections if change filter
                if(value === 'true'){
                  setBoarding(true);
                } else {
                  setBoarding(false);
                }
              }}
              defaultValue={`true`}
              value={boarding}
            >
            <option value={`true`}>
              {businessType === 'Adult Program' ? 'Yes' : 'Boarding'}
            </option>
            <option value={`false`}>
              {businessType === 'Adult Program' ? 'No' : 'Non-Boarding'}
            </option>
            </select>
          </label>
        </div>

        <div className="filters-inner-filter">
          <div className="field__title has_icon">
            <div className="title_text">Registration Option</div>
            <div
              className="infolink"
              onClick={() => {
                if (typeof window.reactOpenPopup === 'function') {
                  window.reactOpenPopup('refundable');
                }
              }}><img src="https://www.imgacademy.com/sites/default/files/information-icon.png" alt="info icon" /></div>
          </div>
          <label className={classNames('field__label')}>
            <select
              name={`filters-price`}
              onChange={(e) => {
                const value = e.target.value;
                // Clear calendar selections if change filter
                setSelectedDay([]);
                setRangeData([]);
                setRanges([]);
                // End Clear calendar selections if change filter
                handleChangeRefundable(value);
              }}
              defaultValue={`Normal`}
              value={refundable}
            >
            {filterPriceTypes.map((value, index) => (
              <option value={value.value}>
                {value.label}
              </option>
            ))}
            </select>
          </label>
        </div>

        {filterLength.length &&
          <div className="filters-inner-filter">
            <div className="field__title">Camp Type</div>
            <label className={classNames('field__label')}>
              <select
                name={`filters-type`}
                onChange={(e) => {
                  const value = e.target.value;
                  // Clear calendar selections if change filter
                  setSelectedDay([]);
                  setRangeData([]);
                  setRanges([]);
                  // End Clear calendar selections if change filter
                  setSelectedLength(value);
                }}
                defaultValue={filterLength[0].value}
                value={selectedLength || filterLength[0].value}
              >
              {filterLength.map((value, index) => (
                <option value={value.value}>
                  {value.label}
                </option>
              ))}
              </select>
            </label>
          </div>
        }

      </div>
    </div>
  );

  const [mainTimezone, setMainTimezone] = useState('UTC');
  console.log('mainTimezone:',mainTimezone);
  const today = new Date(new Date().toLocaleString('en', {timeZone: mainTimezone}));
  const month = today.getMonth();
  const year = today.getFullYear();

  console.log('selectedConcentrationOptions1', selectedConcentrationOptions);

  /* Multiple Weeks */
  const [ranges, setRanges] = useState([]);
  console.log('ranges:',ranges);
  const sortedRanges = [...ranges].sort(function(a,b){
    return new Date(a.capacity_start_date) - new Date(b.capacity_start_date);
  });
  console.log('sortedRanges:',sortedRanges);

  /* Calendar */
  const [calendar, setCalendar] = useState(null);
  console.log('Calendar data',calendar);
  const [calendarHoverDate, setCalendarHoverDate] = useState(null);
  console.log('calendarHoverDate',calendarHoverDate);
  const [selectedDays, setSelectedDays] = useState([]);
  console.log('selectedDays:',selectedDays);
  const [rangeData, setRangeData] = useState([]);
  console.log('rangeData:',rangeData);
  const [defaultMonth, setDefaultMonth] = useState(new Date(year, month));
  console.log('defaultMonth',defaultMonth);
  const [endMonth, setEndMonth] = useState(new Date(year, month));
  console.log('endMonth',endMonth);
  const [numberOfMonths, setNumberOfMonths] = useState(4);
  console.log('numberOfMonths',numberOfMonths);
  var range_data = null;
  const [selectedDay, setSelectedDay] = useState([]);
  console.log('selectedDay',selectedDay);
  const handleDayClick = (day: Date) => {
    setCalendarLocked(true);
    var need_clear = true;
    //const need_clear_day = day;
    if(businessType === 'Adult Program'){
      if(selectedDay.length){
        for (let ii = 0; ii < selectedDay.length; ii++) {
          console.log('CheckSelectedDay', day, selectedDay[ii]);
          if(isWithinInterval(day, {start: selectedDay[ii].capacity_start_date, end: selectedDay[ii].capacity_end_date})){
            setRanges(prevRanges => (
              prevRanges.filter((range, index) => range.capacity_start_date !== selectedDay[ii].capacity_start_date)
            ));
            setSelectedDay(prevSelectedDay => (
              prevSelectedDay.filter((sd, index) => sd.capacity_start_date !== selectedDay[ii].capacity_start_date)
            ));
            setCalendarLocked(false);
            return;
          }
        }
      }
      range_data = calendar.find((r) => isWithinInterval(day, {start: subDays(new Date(new Date(r.capacity_start_date).toLocaleString('en', {timeZone: mainTimezone})), 1), end: new Date(new Date(r.capacity_start_date).toLocaleString('en', {timeZone: mainTimezone}))}));
    } else {
      range_data = calendar.find((r) => isWithinInterval(day, {start: subDays(new Date(new Date(r.capacity_start_date).toLocaleString('en', {timeZone: mainTimezone})), 1), end: new Date(new Date(r.capacity_end_date).toLocaleString('en', {timeZone: mainTimezone}))}));
      if(selectedDay.length){
        var capacity_start_date_check = subDays(new Date(new Date(range_data.capacity_start_date).toLocaleString('en', {timeZone: mainTimezone})), 1);
        var capacity_end_date_check = addDays(new Date(new Date(range_data.capacity_end_date).toLocaleString('en', {timeZone: mainTimezone})), 1);
        for (let ii = 0; ii < selectedDay.length; ii++) {
          if(isWithinInterval(capacity_start_date_check, {start: selectedDay[ii].capacity_start_date, end: selectedDay[ii].capacity_end_date})){
            need_clear = false;
          }
          if(isWithinInterval(capacity_end_date_check, {start: selectedDay[ii].capacity_start_date, end: selectedDay[ii].capacity_end_date})){
            need_clear = false;
          }
        }
        console.log('need_clear0', need_clear, capacity_start_date_check, capacity_end_date_check);
      }
    }

    console.log('RDATA',range_data);
    if(range_data === undefined){
      setCalendarLocked(false);
      return;
    }

    var nextCamps = [];
    if(businessType !== 'Adult Program' && range_data.length_days === 7 && selectedDay.length === 0){
      var current_index = null;
      var not_sale_index = null;
      var day_exist = false;
      for (let i = 0; i < calendar.length; i++) {
        if(current_index !== null){
          var is_sale = false;
          for (let pt = 0; pt < calendar[i].program_types.length; pt++) {
            if(calendar[i].program_types[pt].sold_out === false){
              is_sale = true;
            }
          }
          if(is_sale && not_sale_index === null){
            day_exist = false;
            if(selectedDay.length){
              for (let sd = 0; sd < selectedDay.length; sd++) {
                if(selectedDay[sd].capacity_start_date_check === calendar[i].capacity_start_date.toString() && selectedDay[sd].capacity_end_date_check === calendar[i].capacity_end_date.toString()){
                  day_exist = true;
                }
              }
            }
            if(!day_exist){
              var prev_date = new Date(new Date(nextCamps[nextCamps.length-1].capacity_end_date).toLocaleString('en', {timeZone: mainTimezone}));
              prev_date.setDate(prev_date.getDate() + 1);
              var prev_date_string = prev_date.toISOString().split('T');
              var next_date_string = calendar[i].capacity_start_date.toString().split('T');
              console.log('Dates check', prev_date_string, next_date_string);
              if(prev_date_string[0] === next_date_string[0]){
                nextCamps.push(calendar[i]);
              }
            }
          } else {
            not_sale_index = i;
          }
        }
        if(calendar[i].capacity_start_date === range_data.capacity_start_date && calendar[i].capacity_end_date === range_data.capacity_end_date){
          day_exist = false;
          if(selectedDay.length){
            for (let sd = 0; sd < selectedDay.length; sd++) {
              console.log('selectedDayCheck',selectedDay[sd].capacity_start_date_check, calendar[i].capacity_start_date.toString());
              if(selectedDay[sd].capacity_start_date_check === calendar[i].capacity_start_date.toString() && selectedDay[sd].capacity_end_date_check === calendar[i].capacity_end_date.toString()){
                day_exist = true;
              }
            }
          }
          if(!day_exist){
            current_index = i;
            nextCamps.push(calendar[i]);
          }
        }
      }
      console.log('nextCamps',nextCamps);
    }
    if(nextCamps.length > 1){
      const select = (value) => {
          console.log('nextCamps value',value);
          var nextCamp = {};
          for (let nc = 0; nc < value; nc++) {
            nextCamp = nextCamps[nc];
            console.log('nextCamps select', nextCamp);

            var addToCalendar = function(nextCamp) {
              var start_date = nextCamp.capacity_start_date.split('T');
              var end_date = nextCamp.capacity_end_date.split('T');
              api.fetchConcentrations({
                age,
                boarding: boarding ? 'yes' : 'no',
                gender,
                sport,
                business_type: businessType,
                start_date: start_date[0],
                end_date: end_date[0],
              //}).then((res) => {
              }).then(async function(res) {

                // ESL
                var isESL = false;
                if(nextCamp.program_types.length){
                  console.log('secondaryProgramTypesChecknextCamp1',nextCamp.program_types);
                  for (let i = 0; i < nextCamp.program_types.length; i++) {
                    var program_type = nextCamp.program_types[i];
                    var program_start_date = program_type.start_date.split('T');
                    var program_end_date = program_type.end_date.split('T');
                    var secondaryProgramTypes = await api.fetchCamps({
                      age,
                      boarding: boarding ? 'yes' : 'no',
                      gender,
                      sport: sport,
                      business_type: businessType,
                      start_date: program_start_date[0],
                      end_date: program_end_date[0],
                      length: program_type.program_length,
                      program_type: program_type.name,
                      position_name: position,
                    });
                    console.log('secondaryProgramTypesChecknextCamp2',secondaryProgramTypes);
                    nextCamp.program_types[i].secondaryProgramTypes = secondaryProgramTypes;
                    if(secondaryProgramTypes.results !== undefined && secondaryProgramTypes.results.length){
                      for (let spt = 0; spt < secondaryProgramTypes.results.length; spt++) {
                        if(secondaryProgramTypes.results[spt].secondary_program_type === 'ESL'){
                          isESL = true
                        }
                      }
                    }
                  }
                }

                console.log('handleDayClick fetchConcentrations',res);
                var options = [];
                var option_item = {};
                if (res.results[0].concentrations.length > 0) {
                  option_item = {};
                  option_item.value = 0;
                  option_item.label = 'Week 1 Specialisation';
                  options.push(option_item);
                  for (let i = 0; i < res.results[0].concentrations.length; i++) {
                    option_item = {};
                    option_item.value = res.results[0].concentrations[i].product.id;
                    option_item.label = res.results[0].concentrations[i].name;
                    var concentration_exist = false;
                    for (let io = 0; io < options.length; io++) {
                      if(options[io].value === option_item.value && options[io].label === option_item.label){
                        concentration_exist = true;
                      }
                    }
                    if(!concentration_exist){
                      options.push(option_item);
                    }
                  }
                }
                if(isESL){
                  option_item = {};
                  option_item.value = 1;
                  option_item.label = 'English as a Second Language';
                  options.push(option_item);
                }
                var selected_day_exist = false;
                var new_day = {};
                new_day.capacity_start_date = new Date(new Date(nextCamp.capacity_start_date).toLocaleString('en', {timeZone: mainTimezone}));
                new_day.capacity_end_date = new Date(new Date(nextCamp.capacity_end_date).toLocaleString('en', {timeZone: mainTimezone}));
                new_day.capacity_start_date_check = nextCamp.capacity_start_date;
                new_day.capacity_end_date_check = nextCamp.capacity_end_date;
                new_day.capacity_start_date_formatted = nextCamp.capacity_start_date_formatted;
                new_day.capacity_end_date_formatted = nextCamp.capacity_end_date_formatted;
                if(selectedDay.length){
                  for (let i = 0; i < selectedDay.length; i++) {
                    var checking_selected_day = selectedDay[i];
                    console.log('handleDayClick checking_selected_day check',checking_selected_day,new_day);
                    if(checking_selected_day.capacity_start_date.toString() === new_day.capacity_start_date.toString() && checking_selected_day.capacity_end_date.toString() === new_day.capacity_end_date.toString()){
                      // Deselect
                      selected_day_exist = true;
                      selectedDay.splice(i, 1);
                      console.log('handleDayClick checking_selected_day found',checking_selected_day);
                    }
                  }
                }
                if(!selected_day_exist){
                  selectedDay.push(new_day);
                }
                setSelectedDay(selectedDay);
                setRangeData(nextCamp);
                var exist = false;
                nextCamp.concentrations = options;
                if (res.results[0].concentrations.length > 0) {
                  nextCamp.concentrationsItems = res.results[0].concentrations;
                } else {
                  nextCamp.concentrationsItems = null;
                }
                if(ranges.length){
                  for (let i = 0; i < ranges.length; i++) {
                    var checking_range = ranges[i];
                    if(checking_range === nextCamp){
                      // Deselect
                      exist = true;
                      ranges.splice(i, 1);
                    }
                  }
                }
                if(!exist){
                  //ranges.push(nextCamp);
                  setRanges((prevRanges) => [
                      ...prevRanges,
                      nextCamp,
                  ]);
                } else {
                  setRanges(ranges);
                }
                console.log('handleDayClick setRanges',ranges);
              });
            };
            addToCalendar(nextCamp);
            setCalendarLocked(false);

          }
      };
      window.reactOpenPopup(
        'weekselect',
        nextCamps.length,
        (value) => {
          if (!value) {
            return null;
          }
          select(Number(value));
        }
      );
    } else {
      var range_start_date = range_data.capacity_start_date.split('T');
      var range_end_date = range_data.capacity_end_date.split('T');
      api.fetchConcentrations({
        age,
        boarding: boarding ? 'yes' : 'no',
        gender,
        sport,
        business_type: businessType,
        start_date: range_start_date[0],
        end_date: range_end_date[0],
      //}).then((res) => {
      }).then(async function(res) {

        // ESL
        var isESL = false;
        if(range_data.program_types.length){
          console.log('secondaryProgramTypesCheck1',range_data.program_types);
          for (let i = 0; i < range_data.program_types.length; i++) {
            var program_type = range_data.program_types[i];
            var program_start_date = program_type.start_date.split('T');
            var program_end_date = program_type.end_date.split('T');
            var secondaryProgramTypes = await api.fetchCamps({
              age,
              boarding: boarding ? 'yes' : 'no',
              gender,
              sport: sport,
              business_type: businessType,
              start_date: program_start_date[0],
              end_date: program_end_date[0],
              length: program_type.program_length,
              program_type: program_type.name,
              position_name: position,
            });
            console.log('secondaryProgramTypesCheck2',secondaryProgramTypes);
            range_data.program_types[i].secondaryProgramTypes = secondaryProgramTypes;
            if(secondaryProgramTypes.results !== undefined && secondaryProgramTypes.results.length){
              for (let spt = 0; spt < secondaryProgramTypes.results.length; spt++) {
                if(secondaryProgramTypes.results[spt].secondary_program_type === 'ESL'){
                  isESL = true
                }
              }
            }
          }
        }

        var options = [];
        var options_weeks = [];
        var option_item = {};
        var concentration_exist = false;
        if (res.results.length > 1){
          for (let r = 0; r < res.results.length; r++) {
            var options_item = [];
            option_item = {};
            option_item.value = 0;
            option_item.label = 'Week '+(r+1)+' Specialization';
            options_item.push(option_item);
            for (let i = 0; i < res.results[r].concentrations.length; i++) {
              option_item = {};
              option_item.value = res.results[0].concentrations[i].product.id;
              option_item.label = res.results[0].concentrations[i].name;
              concentration_exist = false;
              for (let io = 0; io < options_item.length; io++) {
                if(options_item[io].value === option_item.value && options_item[io].label === option_item.label){
                  concentration_exist = true;
                }
              }
              if(!concentration_exist){
                options_item.push(option_item);
              }
            }
            if(isESL){
              option_item = {};
              option_item.value = 1;
              option_item.label = 'English as a Second Language';
              options_item.push(option_item);
            }
            options_weeks.push(options_item);
          }
        } else if (res.results[0].concentrations.length > 0) {
          option_item = {};
          option_item.value = 0;
          option_item.label = 'Week 1 Specialisation';
          options.push(option_item);
          for (let i = 0; i < res.results[0].concentrations.length; i++) {
            option_item = {};
            option_item.value = res.results[0].concentrations[i].product.id;
            option_item.label = res.results[0].concentrations[i].name;
            concentration_exist = false;
            for (let io = 0; io < options.length; io++) {
              if(options[io].value === option_item.value && options[io].label === option_item.label){
                concentration_exist = true;
              }
            }
            if(!concentration_exist){
              options.push(option_item);
            }
          }
          if(isESL){
            option_item = {};
            option_item.value = 1;
            option_item.label = 'English as a Second Language';
            options.push(option_item);
          }
        }
        var selected_day_exist = false;
        var new_day = {};
        new_day.capacity_start_date = new Date(new Date(range_data.capacity_start_date).toLocaleString('en', {timeZone: mainTimezone}));
        new_day.capacity_end_date = new Date(new Date(range_data.capacity_end_date).toLocaleString('en', {timeZone: mainTimezone}));
        new_day.capacity_start_date_check = range_data.capacity_start_date;
        new_day.capacity_end_date_check = range_data.capacity_end_date;
        new_day.capacity_start_date_formatted = range_data.capacity_start_date_formatted;
        new_day.capacity_end_date_formatted = range_data.capacity_end_date_formatted;
        if(selectedDay.length){
          for (let i = 0; i < selectedDay.length; i++) {
            var checking_selected_day = selectedDay[i];
            console.log('handleDayClick checking_selected_day check',checking_selected_day,new_day);
            if(checking_selected_day.capacity_start_date.toString() === new_day.capacity_start_date.toString() && checking_selected_day.capacity_end_date.toString() === new_day.capacity_end_date.toString()){
              // Deselect
              selected_day_exist = true;
              selectedDay.splice(i, 1);
              console.log('handleDayClick checking_selected_day found',checking_selected_day);
            }
          }
        }
        if(!selected_day_exist){
          selectedDay.push(new_day);
        }
        if(need_clear && selectedDay.length && businessType !== 'Adult Program'){
          setSelectedDay([new_day]);
          setRangeData(range_data);
        } else {
          setSelectedDay(selectedDay);
          setRangeData(range_data);
        }

        range_data.concentrations = options;
        range_data.concentrationsWeeks = options_weeks;
        range_data.concentrationsItems = null;
        if (res.results.length > 1) {
          range_data.concentrationsItems = res.results;
        } else if (res.results[0].concentrations.length > 0) {
          range_data.concentrationsItems = res.results[0].concentrations;
        }

        var exist = false;
        if(ranges.length){
          for (let i = 0; i < ranges.length; i++) {
            var checking_range = ranges[i];
            if(checking_range === range_data){
              // Deselect
              exist = true;
              //ranges.splice(i, 1);
            }
          }
        }
        if(!exist){

          if(need_clear && selectedDay.length && businessType !== 'Adult Program'){
            // Unselect all if new period out of existings
            setRanges((prevRanges) => [
                range_data
            ]);
          } else {
            setRanges((prevRanges) => [
                ...prevRanges,
                range_data,
            ]);
          }
        } else {
          setRanges(prevRanges => (
            prevRanges.filter((range, index) => range.capacity_start_date !== range_data.capacity_start_date)
          ));
          //setRanges(ranges);

          // Unselect All If Selected
          setSelectedDay([]);
          setRangeData([]);
          setRanges([]);
        }
        /*
        if(!exist){
          ranges.push(range_data);
        }
        setRanges(ranges);
        */
        console.log('handleDayClick ONCE setRanges',ranges);
        setCalendarLocked(false);
      });

    }

  };
  function transformProgram(program, program_type, program_main){
    program.start_date = program.capacity_start_date;
    program.end_date = program.capacity_end_date;
    program.capacity = program.capacity_available;
    program.program_length_days = program.length_days;
    program.main_id = program_type.id;
    program.top_id = program_main.id;
    return program;
  }
  /*
  function sortRanges(ranges){
    ranges.sort(function(a,b){
      return new Date(a.capacity_start_date) - new Date(b.capacity_start_date);
    });
    return ranges;
  }
  */
  const handleAdd = async (program, selectedSpecialization, ranges) => {
    const start = Date.now();
    window.locked = true;
    setLocked(true);
    //ranges = sortRanges(ranges);
    var hasESLselected = false;
    if(selectedSpecialization.length){
      for (let i = 0; i < selectedSpecialization.length; i++) {
        if(selectedSpecialization[i].value === '1'){
          hasESLselected = true;
        }
      }
    }
    console.log('AddCheck0', hasESLselected);
    console.log('AddCheck1', program);
    console.log('AddCheck2', selectedSpecialization);
    console.log('AddCheck3', ranges);
    var products = [];
    for (let i = 0; i < ranges.length; i++) {
      var range = ranges[i];
      for (let ii = 0; ii < range.program_types.length; ii++) {
        var program_type = range.program_types[ii];
        if(program_type.name === program.name){

          var programESL = {};
          if(program_type.secondaryProgramTypes !== undefined){
            if(program_type.secondaryProgramTypes.results !== undefined && program_type.secondaryProgramTypes.results.length){
              for (let spt = 0; spt < program_type.secondaryProgramTypes.results.length; spt++) {
                if(program_type.secondaryProgramTypes.results[spt].secondary_program_type === 'ESL'){
                  programESL = program_type.secondaryProgramTypes.results[spt];
                }
              }
            }
          }
          if(programESL['id'] !== undefined && hasESLselected){
            console.log('AddCart1.2 from:',program_type);
            console.log('AddCart1.2 to:',programESL);
            program_type = transformProgram(programESL, program_type, program);
          }

          products.push(program_type);
          switch (selectedLength) {
            case PROGRAM_TYPES.WEEKLY_CAMP:
              await addCamp(program_type);
              setProgramType({
                type: selectedLength,
                weeksLength: programLengthInWeeks + 1,
              });
              break;
            default:
              const incrementDays = (programLengthInDays || 0) + program_type.program_length_days;
              setProgramType({
                type: selectedLength,
                weeksLength: Math.floor(incrementDays / 7),
                daysLength: incrementDays,
              });
              await addCamp(program_type);
              break;
          }
        }
      }
    }

    // Add Specialization
    if(selectedSpecialization.length && !hasESLselected){
      setConcentrationDataLength(selectedSpecialization.length);
      var weeknum = 1;
      for (let ss = 0; ss < selectedSpecialization.length; ss++) {
        var specialization = selectedSpecialization[ss];
        if(parseInt(specialization.value) === 1){
          setSkipConcentrations(true);
        }
        for (let ci = 0; ci < ranges.length; ci++) {
          if(ranges[ci].concentrationsItems){
            var concentrationsItems = ranges[ci].concentrationsItems;
            if(ranges[ci].concentrationsWeeks !== undefined && ranges[ci].concentrationsWeeks.length){
              for (let ci = 0; ci < concentrationsItems.length; ci++) {
                for (let i = 0; i < concentrationsItems[ci].concentrations.length; i++) {
                  if(concentrationsItems[ci].concentrations[i].product.id === parseFloat(specialization.value)){
                    var concentration_product_item = concentrationsItems[ci].concentrations[i].product;
                    console.log('concentration_product_item'+weeknum+':', concentration_product_item);
                    const res = await addProductToCart({
                      type: 'concentration',
                      product: concentration_product_item,
                    });
                    console.log('addConcentration'+weeknum+':', res);
                    if (res) {
                      selectConcentrationOption(concentration_product_item.id, {
                        participantProductId: res.participant_product_id,
                        weekName: 'week_'+weeknum,
                        name: concentration_product_item.raw_name,
                        product: concentration_product_item,
                        camp_id: program.id,
                      });
                      weeknum++;
                      gtm.trackAddToCart(concentration_product_item, 'concentration');
                    }
                  }
                }
              }
            } else {
              for (let i = 0; i < concentrationsItems.length; i++) {
                if(concentrationsItems[i].product.id === parseFloat(specialization.value)){
                  var concentration_product = concentrationsItems[i].product;
                  const res = await addProductToCart({
                    type: 'concentration',
                    product: concentration_product,
                  });
                  if (res) {
                    var weekName = parseInt(specialization.week);
                    console.log('AddCart6('+weekName+'):', specialization);
                    selectConcentrationOption(concentration_product.id, {
                      participantProductId: res.participant_product_id,
                      weekName: 'week_'+weekName,
                      name: concentration_product.raw_name,
                      product: concentration_product,
                      camp_id: program.id,
                    });
                    gtm.trackAddToCart(concentration_product, 'concentration');
                  }
                }
              }
            }
          }
        }
      }
    } else {
      setSkipConcentrations(true);
    }

    const end = Date.now();
    console.log(`Execution time: ${end - start} ms`);
  };
  const handleRemove = async (program, ranges) => {
    window.locked = false;
    setLocked(false);
    console.log('Remove from cart0:', selectedConcentrationOptions);
    if(Object.keys(selectedConcentrationOptions).length){
      for (const [key, value] of Object.entries(selectedConcentrationOptions)) {
        console.log('Remove from cart0.1('+key+'):', value);
        deselectConcentrationOption(value.participantProductId);
        removeProductFromCart(value.participantProductId);
      }
    }
    console.log('Remove from cart1:', selectedConcentrationOptions);
    for (let i = 0; i < ranges.length; i++) {
      var range = ranges[i];
      for (let ii = 0; ii < range.program_types.length; ii++) {
        var program_type = range.program_types[ii];
        if(program_type.name === program.name){

          removeCamp(program_type.id);
          var decrementWeeks = programLengthInWeeks - 1;
          setProgramType({
            type: selectedLength,
            weeksLength: decrementWeeks > 0 ? decrementWeeks : null,
          });
        }
      }
    }

  };
  const renderDayPickerInfo = () => {
    return (
      <div className="calendarNoteHolder">
        <div className="rdp-day-info-wrapper">
          <span className="rdp-day-info rdp-day-info-avialable"></span> Avialable
          <span className="rdp-day-info rdp-day-info-soldout"></span> Sold Out
          <span className="rdp-day-info rdp-day-info-selected"></span> Selected
        </div>
        <div className="calendarNote">
          <p>Not finding what you want? Call us at (<a href="tel:1-800-872-6425">1-800-872-6425</a>) and a camp advisor can assist.</p>
        </div>
      </div>
    );
  };

  const renderDayPickerDates = () => {
    var dates = selectedDay;
    dates.sort(function(a, b) {
      var c = a.capacity_start_date;
      var d = b.capacity_start_date;
      return c-d;
    });
    return dates[0].capacity_start_date_formatted+' - '+dates[dates.length-1].capacity_end_date_formatted;
  };

  const renderPrograms = () => {
    console.log('renderPrograms:',rangeData);
    console.log('ranges in programs:',ranges);
    console.log('sortedRanges in programs:',sortedRanges);
    console.log('selectedDay in programs:',selectedDay);
    if (rangeData['capacity_start_date'] && selectedDay.length && ranges.length) {
      if(businessType !== 'Adult Program'){
        return (
          <div className="program-types-wrapper">
            <div className="program-types-header">
              Avialable Camps for {renderDayPickerDates()}
            </div>
            <div className="programsHolder">
              <div className="program-types">
                {rangeData.program_types.map((program, index) => {
                  return (
                    <SpecializationItem
                      key={`${program.id}-${index}`}
                      index={index}
                      program={program}
                      rangeData={rangeData}
                      onAdd={(program, selectedSpecialization, sortedRanges) => handleAdd(program, selectedSpecialization, sortedRanges)}
                      onRemove={(program, sortedRanges) => handleRemove(program, sortedRanges)}
                      isSelected={!!selectedCampOptions[program.id]}
                      refundable={refundable}
                      selectedCampOptions={selectedCampOptions}
                      ranges={sortedRanges}
                    />
                  );
                })}
              </div>
            </div>
            <div class="compare-programs">
              <div class="textlink" onClick={() => {
                if (typeof window.openCompareProgramsPopup === 'function') {
                  window.openCompareProgramsPopup();
                }
              }}
              >Compare Training Programs</div>
              <div class="infolink" onClick={() => {
                if (typeof window.openCompareProgramsPopup === 'function') {
                  window.openCompareProgramsPopup();
                }
              }}
              ><img src="https://www.imgacademy.com/sites/default/files/information-icon.png" alt="info icon" /></div>
            </div>
          </div>
        );
      } else {
        return (
          <div className="program-types-wrapper">
            <div className="program-types-header">
              Avialable Camps for {renderDayPickerDates()}
            </div>
            <div className="programsHolder">
              <div className="program-types">
                {rangeData.program_types.map((program, index) => {
                  return (
                    <SpecializationItem
                      key={`${program.id}-${index}`}
                      index={index}
                      program={program}
                      rangeData={rangeData}
                      onAdd={(program, selectedSpecialization, sortedRanges) => handleAdd(program, selectedSpecialization, sortedRanges)}
                      onRemove={(program, sortedRanges) => handleRemove(program, sortedRanges)}
                      isSelected={!!selectedCampOptions[program.id]}
                      refundable={refundable}
                      selectedCampOptions={selectedCampOptions}
                      ranges={sortedRanges}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        );
      }
    }
  };

  var modifiers = {}

  useEffect(() => {
    console.log('selectedDayExist:check',selectedDay);
  },[selectedDays, selectedDay, modifiers, businessType])

  if(businessType !== 'Adult Program'){
    modifiers = {
      firstrange: day => selectedDays.some((r) => isSameDay(day, r.from)),
      lastrange: day => selectedDays.some((r) => isSameDay(day, r.to)),
      hoverinterval: day => selectedDays.some((r) => (calendarHoverDate && (isWithinInterval(day, {start: subDays(r.from, 1), end: r.to}) && isWithinInterval(calendarHoverDate, {start: subDays(r.from, 1), end: r.to})))),
      selectedinterval: day => selectedDays.some((r) => (isWithinInterval(day, {start: subDays(r.from, 1), end: r.to}) && selectedDay.some((sd) => (isWithinInterval(sd.capacity_start_date, {start: subDays(r.from, 1), end: r.to}) && isWithinInterval(sd.capacity_end_date, {start: subDays(r.from, 1), end: r.to})))  )),
      soldout: day => selectedDays.some((r) => (isWithinInterval(day, {start: subDays(r.from, 1), end: r.to}) && r.program_types.every((pt) => (pt.sold_out)))),
    };
  } else {
    var newSelectedDays = selectedDays;
    if(selectedDays.length){
      for (let i = 0; i < newSelectedDays.length; i++) {
        var exist = false;
        for (let ii = 0; ii < selectedDay.length; ii++) {
          console.log('selectedDayExist:true',selectedDay[ii]);
          if(selectedDay[ii].capacity_start_date.toString() === newSelectedDays[i].from.toString() && selectedDay[ii].capacity_end_date.toString() === newSelectedDays[i].to_end.toString()){
            exist = true;
          }
        }
        if(exist){
          newSelectedDays[i].to = newSelectedDays[i].to_end;
          newSelectedDays[i].remove = false;
          console.log('selectedDebug exist',newSelectedDays[i]);
        } else {
          newSelectedDays[i].to = newSelectedDays[i].from;
          if(newSelectedDays[i].remove !== undefined){
            delete newSelectedDays[i].remove;
          }
          console.log('selectedDayExist:restore',newSelectedDays[i]);
        }
      }
      for (let i = 0; i < newSelectedDays.length; i++) {
        newSelectedDays[i].display = true;
        if(selectedDay.length){
          for (let ii = 0; ii < selectedDay.length; ii++) {
            if(newSelectedDays[i].remove === undefined){
              if(isWithinInterval(newSelectedDays[i].from, {start: selectedDay[ii].capacity_start_date, end: selectedDay[ii].capacity_end_date})){
                newSelectedDays[i].display = false;
                console.log('selectedDebug remove',newSelectedDays[i]);
              }
            }
          }
        }
      }
    }
    console.log('selectedDebug-0',selectedDays);
    console.log('selectedDebug-1',newSelectedDays);
    modifiers = {
      firstrange: day => newSelectedDays.some((r) => (r.display && isSameDay(day, r.from))),
      lastrange: day => newSelectedDays.some((r) => (r.display && isSameDay(day, r.to))),
      selectedinterval: day => newSelectedDays.some((r) => (r.display && (isWithinInterval(day, {start: subDays(r.from, 1), end: r.to}) && selectedDay.some((sd) => (isWithinInterval(sd.capacity_start_date, {start: subDays(r.from, 1), end: r.to}) && isWithinInterval(sd.capacity_end_date, {start: subDays(r.from, 1), end: r.to})))  ))),
      soldout: day => newSelectedDays.some((r) => (r.display && (isWithinInterval(day, {start: subDays(r.from, 1), end: r.to}) && r.program_types.every((pt) => (pt.sold_out))))),
    };
  }

  const handleDayMouseEnter = (day: Date, activeModifiers: ActiveModifiers, e: MouseEvent) => {
    if(businessType !== 'Adult Program'){
      setCalendarHoverDate(day);
    }
  };
  const handleDayMouseLeave = (day: Date, activeModifiers: ActiveModifiers, e: MouseEvent) => {
    if(businessType !== 'Adult Program'){
      setCalendarHoverDate(null);
    }
  };
  const modifiersClassNames = {
    firstrange: 'first-in-range',
    lastrange: 'last-in-range',
  };
  const modifiersStyles = {
    firstrange: {
      borderTopLeftRadius: 18,
      borderBottomLeftRadius: 18,
    },
    lastrange: {
      borderTopRightRadius: 18,
      borderBottomRightRadius: 18,
    },
    selecteddate: {
      backgroundColor: '#000000',
    },
    hoverinterval: {
      backgroundColor: '#d7d9dd',
    },
    selectedinterval: {
      backgroundColor: '#9ADBAB',
    },
    soldout: {
      backgroundColor: '#f29fa2',
    },
  };

  useEffect(() => {
    setCartRefundable(defaultRefundable);
    window.refundable = defaultRefundable;
  }, [defaultRefundable, setCartRefundable]);
  const handleChangeRefundable = (value) => {
    setCartRefundable(value);
    window.refundable = value;
  };

  useEffect(() => {
    if (!selectedLength) {
      return;
    }
    var fetchCalendarOptions = {
      boarding: boarding ? 'yes' : 'no',
      gender,
      age,
      sport,
      business_type: businessType,
      price_type: refundable,
      secondary_group: selectedLength,
    };
    if(mainPosition !== 'Default'){
      fetchCalendarOptions.position_name = mainPosition;
    }
    api
      .fetchCalendar(fetchCalendarOptions)
      .then((res) => {
        console.log('Calendar loaded',res);
        if (res) {
          setMainTimezone(res.timezone);
          var dates = [];
          for (let i = 0; i < res.results.length; i++) {
            if(businessType === 'Adult Program'){
              dates.push({
                from: new Date(new Date(res.results[i].capacity_start_date).toLocaleString('en', {timeZone: mainTimezone})),
                to: new Date(new Date(res.results[i].capacity_start_date).toLocaleString('en', {timeZone: mainTimezone})),
                to_end: new Date(new Date(res.results[i].capacity_end_date).toLocaleString('en', {timeZone: mainTimezone})),
                program_types: res.results[i].program_types,
              });
            } else {
              dates.push({
                from: new Date(new Date(res.results[i].capacity_start_date).toLocaleString('en', {timeZone: mainTimezone})),
                to: new Date(new Date(res.results[i].capacity_end_date).toLocaleString('en', {timeZone: mainTimezone})),
                program_types: res.results[i].program_types,
              });
            }
          }
          if(dates.length){
            const mindate = new Date(new Date(dates[0].from).toLocaleString('en', {timeZone: mainTimezone}));
            const mindate_month = mindate.getMonth();
            const mindate_year = mindate.getFullYear();
            const mindate_day = mindate.getDate();
            setDefaultMonth(new Date(new Date(mindate_year, mindate_month, mindate_day).toLocaleString('en', {timeZone: mainTimezone})));
            console.log('LastDate0:', dates[dates.length-1]);
            var maxdate = new Date(new Date(dates[dates.length-1].to).toLocaleString('en', {timeZone: mainTimezone}));
            if(businessType === 'Adult Program'){
              maxdate = new Date(new Date(dates[dates.length-1].to_end).toLocaleString('en', {timeZone: mainTimezone}));
            }
            console.log('LastDate1:', maxdate);
            const maxdate_month = maxdate.getMonth();
            const maxdate_year = maxdate.getFullYear();
            const maxdate_day = maxdate.getDate();
            console.log('LastDate2:', maxdate_day);
            setEndMonth(new Date(new Date(maxdate_year, maxdate_month, maxdate_day).toLocaleString('en', {timeZone: mainTimezone})));
            const monthDiff = (d1, d2) => {
              let months;
              months = (d2.getFullYear() - d1.getFullYear()) * 12;
              months -= d1.getMonth();
              months += d2.getMonth();
              return months <= 0 ? 0 : months;
            }
            const totalMonth = monthDiff(mindate, maxdate);
            setNumberOfMonths(totalMonth+1);
          }
          setSelectedDays(dates);
          setCalendar(res.results);
          setNoData(false);
          gtm.trackChange(TYPES.OR_CAMPER_CALENDAR);
        } else {
          console.log('MAINERROR in calendar');
          setSelectedDays([]);
          setSelectedDay([]);
          setRangeData([]);
          setRanges([]);
          setCalendar(null);
          setNoData(true);
        }
      });
  }, [
    initialDate,
    boarding,
    gender,
    age,
    position,
    refundable,
    sport,
    businessType,
    selectedLength,
    mainTimezone,
    mainPosition
  ]);

  /*
  useEffect(() => {
    let skip = false;
    if (!sport || !age || !gender || !businessType) {
      return;
    }
    api
      .fetchSeasons({
        boarding: boarding ? 'yes' : 'no',
        gender,
        age,
        sport,
        business_type: businessType,
        refundable: refundable,
        position_name: position,
      })
      .then((res) => {
        if (res && !skip) {
          setCamps(res.results);
          gtm.trackChange(TYPES.OR_CAMPER_CALENDAR);
        }

        if (!res) {
          setCamps([]);
        }
      });

    return () => (skip = true);
  }, [
    initialDate,
    boarding,
    gender,
    age,
    position,
    refundable,
    sport,
    businessType,
  ]);
  */

  useEffect(() => {
    if (!sport) {
      return;
    }
    //setLimit(LIMIT);

    api
      .fetchHistogram({
        group_by: 'business_type',
        age,
        gender,
        sport,
        boarding: boarding ? 'yes' : 'no',
      })
      .then((res) => {
        if (!res) {
          return;
        }

        // Check for adult and Get Gears products
        var isAdult = false;
        if (res.results.business_type && res.results.business_type.length === 1) {
          for (let business_type of res.results.business_type) {
            if(business_type.name === 'Adult Program'){
              isAdult = true;
            }
          }
        }

        api.getImgorShopifyGearProductsByCollection(isAdult);

        console.log('Step2 fetchHistogram', res.results);
        console.log('Step2 age', age);
        console.log('Step2 gender', gender);
        console.log('Step2 sport', sport);
        console.log('Step2 boarding', boarding);

      });

  }, [boarding, age, gender, sport]);

  /*
  // Set date and secondary group from retargeting data, or default for first combination
  useEffect(() => {
    if (!camps) {
      return;
    }

    let indexes;

    // Set date from retargeting
    // Initial date format: "June - September 2020"
    if (initialDate) {
      const spaceIndex = initialDate.lastIndexOf(' ');
      const months = initialDate.slice(0, spaceIndex); // June - September
      const year = initialDate.slice(spaceIndex + 1); // 2020

      for (let i = 0; i < camps.length; i++) {
        for (let j = 0; j < camps[i].months.length; j++) {
          if (
            year === camps[i].name &&
            months === camps[i].months[j].name &&
            camps[i].months[j].has_camps
          ) {
            indexes = [i, j];
            i = camps.length;
            break;
          }
        }
      }
    }

    // Search for first date that has camps
    if (!indexes) {
      for (let i = 0; i < camps.length; i++) {
        for (let j = 0; j < camps[i].months.length; j++) {
          if (camps[i].months[j].has_camps) {
            indexes = [i, j];
            // Break from outer loop
            i = camps.length;
            break;
          }
        }
      }
    }

    setYearMonthIndexes(indexes ?? []);

    // Set secondary group (tab index)
    if (initialSecondaryGroup && indexes) {
      const index = camps[indexes[0]].months[
        indexes[1]
      ].program_types.findIndex((pt) => pt.name === initialSecondaryGroup);

      if (index > -1) {
        setTabIndex(index);
      }
    }
  }, [initialDate, initialSecondaryGroup, camps]);

  useEffect(() => {
    if (!camps || !yearMonthIndexes) {
      return;
    }

    if (Array.isArray(yearMonthIndexes) && 0 === yearMonthIndexes.length) {
      return;
    }

    const year = camps[yearMonthIndexes[0]];
    if (!year) {
      return;
    }

    const months = year.months[yearMonthIndexes[1]];
    if (!months) {
      return;
    }

    const programs = months.program_types;
    if (!programs) {
      return;
    }

    setPrograms(programs);
    setProgramPeriod(`${months.name} ${year.name}`);
    setTabIndex(0);
  }, [camps, yearMonthIndexes, setProgramPeriod]);

  useEffect(() => {
    if (!programs) {
      return;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabIndex]);

  const renderNotFound = () => {
    return (
      <div>
        <div className="camp-datas-unavailable">
          <h3>Sorry, no camps found</h3>
          <p>Change your selections above</p>
        </div>
      </div>
    );
  };

  if (!programs) {
    return renderNotFound();
  }
  */

  const addCamp = async (camp) => {
    await resetOptions();

    const secondaryProgramTypes = await api.fetchCamps({
      age,
      boarding: boarding ? 'yes' : 'no',
      gender,
      sport: sport,
      business_type: businessType,
      start_date: camp.start_date,
      end_date: camp.end_date,
      length: camp.program_length,
      program_type: camp.name,
      position_name: position,
    });

    const enhancedCampResult = await api.fetchCamp(camp.id, true);
    console.log('addCamp0:', camp);
    console.log('addCamp1:', enhancedCampResult);
    const res = await addProductToCart({
      type: 'camp',
      product: enhancedCampResult.results[0],
    });

    console.log('addProductToCart:', res);

    if (!res) {
      console.error('An error happened!');
      return;
    }

    console.log('Before serializeCamp:', camp);
    console.log('Before serializeCamp1:', secondaryProgramTypes);

    var sca = {
      ...serializeCamp(camp),
      participantProductId: res.participant_product_id,
      secondaryProgramTypes: secondaryProgramTypes.results,
      product: enhancedCampResult.results[0],
    };
    if(camp.main_id !== undefined){
      sca.main_id = camp.main_id;
    }
    if(camp.top_id !== undefined){
      sca.top_id = camp.top_id;
    }
    console.log('selectCampOption', sca);
    selectCampOption(camp.id, sca);

    gtm.trackAddToCart(camp, 'camp');
  };

  const removeCamp = async (id) => {
    await resetOptions();
    console.log('removeCamp1', selectedCampOptions);
    console.log('removeCamp2', id);
    console.log('removeCamp3', selectedCampOptions[id]);
    if(Object.keys(selectedCampOptions).length){
        for (const [key, value] of Object.entries(selectedCampOptions)) {
          console.log('removeCamp4('+key+')', value);
          if(value.main_id !== undefined && parseInt(value.main_id) === parseInt(id)){
            id = value.id;
          }
        }
    }
    console.log('removeCamp5', selectedCampOptions);
    console.log('removeCamp6', id);
    await removeProductFromCart(selectedCampOptions[id].participantProductId);
    deselectCampOption(id);
  };

  /*
  const replaceCamp = async (camp, id) => {
    await resetOptions();

    const enhancedCampResult = await api.fetchCamp(camp.id, true);
    const res = await replaceProductInCart(
      {
        type: 'camp',
        product: enhancedCampResult.results[0],
      },
      selectedCampOptions[id].participantProductId
    );

    if (!res) {
      console.error('An error happened!');
      return;
    }

    deselectCampOption(id);

    const secondaryProgramTypes = await api.fetchCamps({
      age,
      boarding: boarding ? 'yes' : 'no',
      gender,
      sport: sport,
      business_type: businessType,
      start_date: camp.start_date,
      end_date: camp.end_date,
      length: camp.program_length,
      program_type: camp.name,
      position_name: position,
    });

    selectCampOption(camp.id, {
      ...serializeCamp(camp),
      participantProductId: res.participant_product_id,
      secondaryProgramTypes: secondaryProgramTypes.results,
      product: enhancedCampResult.results[0],
    });
  };
  */

  /*
  const renderSwitch = (param) => {
    let params = param;
    switch(params) {
      case 'IMG Camp':
        return 'Our foundational experience that includes twice-daily training with our expert coaches';
      case 'Total Athlete':
        return 'Camp + includes additional performance training specialization sessions';
      case 'Breakthrough':
        return 'Camp + includes additional personalized training sessions with our coaches';
      case 'Game Changer':
        return 'Our most comprehensive and customizable instruction featuring Camp + Total Athlete + Breakthrough';
      default:
        return '';
    }
  }

  const renderTableHead = (camps) => {
    let cols = camps && camps[0].program_type;

    return (
      <tr>
        <th />

        {cols &&
          cols.map((col) => (
            <th key={col.name} className="program-name">
              {col.display_name || col.name}
              <br />
              <span>{renderSwitch(col.display_name || col.name)}</span>
            </th>
          ))}
      </tr>
    );
  };

  const renderCampCells = (camps, currentCamp, program, index) => {
    if (!currentCamp.program_type) {
      return null;
    }

    return currentCamp.program_type.map((pt) => {
      const isSelected = selectedCampOptions[pt.id];
      const isSoldOut = pt.sold_out;
      const selectedInSameRow = Object.keys(selectedCampOptions)
        .filter((id) => Number(id) !== pt.id)
        .find((id) =>
          currentCamp.program_type.find((pt) => Number(id) === pt.id)
        );
      const isUnavailable = pt.price === 'n/a';

      return (
        <td className="camp-program-holder">
          <div
            key={pt.name}
            className={classNames('camp-program', {
              'camp-program--selected': isSelected,
              'camp-program--sold-out': isSoldOut,
              'camp-program--disabled': selectedInSameRow,
              'camp-program--not-available': isUnavailable,
            })}
            onClick={async () => {
              if (isSoldOut || isUnavailable) {
                console.info(
                  'Trying to click an unappropriate camp, nothing will happen!'
                );
                return;
              }

              console.log('renderCampCells0',program);
              console.log('renderCampCells1',pt);
              console.log('renderCampCells2',PROGRAM_TYPES);
              console.log('renderCampCells3',camps);

              switch (program.name) {
                // Weekly camp selection logic
                case PROGRAM_TYPES.WEEKLY_CAMP:
                  // If the selected camp is clicked, we deselect it
                  if (isSelected) {
                    removeCamp(pt.id);

                    const decrementWeeks = programLengthInWeeks - 1;
                    setProgramType({
                      type: program.name,
                      weeksLength: decrementWeeks > 0 ? decrementWeeks : null,
                    });
                    break;
                  }

                  // When customer has added a camp in the same row
                  // Then wants to change it!
                  // Program length will remain the same
                  if (selectedInSameRow) {
                    replaceCamp(pt, selectedInSameRow);
                    break;
                  }

                  // When there is undefined program type, we need to ask for weeks length
                  // Then select all the programs that come there
                  if (!programType) {
                    // Add next camps
                    const nextCamps = camps
                      .slice(index + 1)
                      .map((c) => ({
                        date: c.date,
                        ...c.program_type.find((type) => type.name === pt.name),
                      }))
                      .filter((c) => !c.sold_out && c.price !== 'n/a');

                    console.log('renderCampCells4',nextCamps);

                    const select = (value) => {
                      setProgramType({
                        type: program.name,
                        weeksLength: value,
                      });

                      // Add clicked camp
                      addCamp(pt);

                      nextCamps
                        .slice(0, value - 1)
                        .map((next) => addCamp(next, next.date));
                    };

                    if (nextCamps.length > 0) {
                      window.reactOpenPopup(
                        'weekselect',
                        nextCamps.length + 1,
                        (value) => {
                          if (!value) {
                            return null;
                          }

                          select(Number(value));
                        }
                      );
                    } else {
                      select(1);
                    }
                    break;
                  }

                  // Last case when we click on a camp that is not selected
                  // We should also increment the program length
                  addCamp(pt);
                  setProgramType({
                    type: program.name,
                    weeksLength: programLengthInWeeks + 1,
                  });

                  break;
                // Other than Weekly Camp 3/5 Camp selection logic, 3/5 days camps, Daily camps
                default:
                  if (isSelected) {
                    const decrementDays =
                      programLengthInDays - pt.program_length_days;
                    setProgramType({
                      type: program.name,
                      weeksLength:
                        decrementDays > 0
                          ? Math.floor(decrementDays / 7)
                          : null,
                      daysLength: decrementDays > 0 ? decrementDays : null,
                    });
                    removeCamp(pt.id);
                    break;
                  }

                  if (selectedInSameRow) {
                    replaceCamp(pt, selectedInSameRow);
                    break;
                  }

                  const incrementDays =
                    (programLengthInDays || 0) + pt.program_length_days;
                  setProgramType({
                    type: program.name,
                    weeksLength: Math.floor(incrementDays / 7),
                    daysLength: incrementDays,
                  });
                  addCamp(pt);
                  break;
              }
            }}
          >
            <div className="camp-price-holder">
              <span>{pt.price !== 'n/a' ? formatPrice(pt.price) : 'n/a'}</span>
              <span
                className={classNames('sold-out-message', {
                  'is-sold-out': isSoldOut,
                })}
              >
                {pt.display_sold_out ? 'Sold Out' : 'N/A'}
              </span>
            </div>
          </div>
        </td>
      );
    });
  };

  const renderTableBody = (camps, program) => {
    const sliced = camps.slice(0, limit);

    return (
      <Fragment>
        {sliced.map((camp, i) => (
          <tr key={camp.date}>
            <td className="camp-date">{camp.date}</td>

            {renderCampCells(camps, camp, program, i)}
          </tr>
        ))}

        {limit < camps.length && (
          <tr className="lastRow">
            <td colSpan="10">
              <button
                className="camp-dates-table__load-more"
                onClick={() => setLimit(limit + LIMIT)}
              >
                Load more dates
              </button>
            </td>
          </tr>
        )}
      </Fragment>
    );
  };

  const renderTabs = () => {
    if (programs.length === 0) {
      return (
        <p className="camp-datas-unavailable">
          No available camps for this period
        </p>
      );
    }

    return (
      <Tabs
        className="camp-dates-tabs"
        selectedIndex={tabIndex}
        onSelect={(index) => {
          setLimit(LIMIT);
          setTabIndex(index);
          gtm.trackChange(TYPES.OR_CAMPER_PROGRAM);
        }}
      >
        <TabList className="camp-dates-tabs__list">
          {programs.map((p, i) => (
            <Tab key={`${p.name}-${i}`}>{p.name}</Tab>
          ))}
        </TabList>

        {programs.map((p, i) => {
          let camps = p.dates['camps'];

          // XXX We need to filter camp's program types that is set to n/a in all
          if (camps) {
            // We start by looping program types
            for (let i = 0; i < camps[0].program_type.length; i++) {
              // Loop over camps, to check if at least one of its pt is other than n/a
              let na = true;
              for (let j = 0; j < camps.length; j++) {
                if (camps[j].program_type[i].price !== 'n/a') {
                  na = false;
                  break;
                }
              }

              if (na) {
                // once all pt in an index has n/a, only keep pt in other indexes
                // Camps is now updated :D
                camps = camps.map((camp) => ({
                  ...camp,
                  program_type: camp.program_type.filter(
                    (pt, index) => index !== i
                  ),
                }));
                i--; // Update program type length after filtering
              }
            }
          }

          return (
            <TabPanel key={`${p.name}-${i}`} className="camp-dates-tabs__panel">
              {!!camps ? (
                <table className="camp-dates-table table table-striped table-condensed">
                  <thead>{renderTableHead(camps)}</thead>
                  <tbody>{renderTableBody(camps, p)}</tbody>
                  <tfoot>
                    <tr>
                      <td colSpan="10">
                        <p className="proTip">
                          PRO TIP: You can select multiple camps to book longer
                          stays
                        </p>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              ) : (
                <div className="camp-date-empty">
                  <p className="camp-date-empty__message">
                    {locales.no_camps_message}
                  </p>
                </div>
              )}
            </TabPanel>
          );
        })}
      </Tabs>
    );
  };
  */

  const handleDayPickerLeftClick = () => {
    const container = document.getElementsByClassName('rdp-months')[0];
    container.scrollBy(-280, 0);
  };

  const handleDayPickerRightClick = () => {
    const container = document.getElementsByClassName('rdp-months')[0];
    container.scrollBy(280, 0);
  };

  const renderCampsBody = () => {
    return (
      <div>
        {filtersWrapper}
        {noData &&
          <div className="no-data-wrapper">No camps found. Change your selections or call <a href="tel:1-800-872-6425">1-800-872-6425</a> to speak with a camp advisor.</div>
        }
        {calendar &&
          <div className="calendar-main-wrapper">
            <div className="cal-holder">
              {window.locked &&
                <div class="locked"></div>
              }
              {calendarLocked &&
                <div class="calendar-locked"><div class="calendar-locked-inner">Please wait...</div></div>
              }
              <div className="calendar-nav-wrapper">
                <div className="day-picker-left-click icon-arrow-left" onClick={handleDayPickerLeftClick}></div>
                <div className="day-picker-right-click icon-arrow-right" onClick={handleDayPickerRightClick}></div>
              </div>
              <DayPicker
                numberOfMonths={numberOfMonths}
                month={defaultMonth}
                fromMonth={defaultMonth}
                toDate={endMonth}
                pagedNavigation
                selected={selectedDays}
                modifiers={modifiers}
                modifiersStyles={modifiersStyles}
                modifiersClassNames={modifiersClassNames}
                onDayClick={handleDayClick}
                onDayMouseEnter={handleDayMouseEnter}
                onDayMouseLeave={handleDayMouseLeave}
              />
            </div>
            {renderDayPickerInfo()}
            {renderPrograms()}
          </div>
        }
        {/*
        <div className="old-holder" style={{display: 'none' }}>
          <div className="flex holder">
            <div className="field__select">
              <select
                value={yearMonthIndexes.join('.')}
                onChange={(e) => {
                  setLimit(LIMIT);

                  const indexes = e.target.value.split('.');
                  setYearMonthIndexes(indexes);
                  setTabIndex(0);
                }}
              >
                {camps.map((year, yIndex) => (
                  <optgroup key={year.name} label={year.name}>
                    {year.months.map((month, mIndex) => {
                      if (!month.has_camps) {
                        return null;
                      }

                      return (
                        <option
                          key={`${month.name}-${month.year}`}
                          value={`${yIndex}.${mIndex}`}
                        >
                          {month.name}
                        </option>
                      );
                    })}
                  </optgroup>
                ))}
              </select>
            </div>

            <div
              className="camp-dates__overview-btn"
              onClick={() => {
                if (typeof window.reactOpenPopup === 'function') {
                  window.reactOpenPopup(isAdult ? 'adult-programs' : 'programs');
                }
              }}
            >
              <div className="image-holder">
                <img
                  src="//www.imgacademy.com/sites/default/files/compare-programs.jpg"
                  alt="camp comparison"
                />
              </div>
              <div className="message-holder">Compare Training Programs</div>
            </div>
          </div>

          {renderTabs()}
        </div>
        */}
      </div>
    );
  };

  return (
    <div className="camp-dates">
      {renderCampsBody()}
    </div>
  );

  /*
  return (
    <div className="camp-dates">
      {yearMonthIndexes.length ? renderCampsBody() : renderNotFound()}
    </div>
  );
  */
};

const mapStateToProps = (state) => ({
  boarding: state.form.boarding,
  gender: state.form.camper.gender,
  age: state.form.camper.age,
  position: state.form.camper.position,
  mainPosition: state.form.camper.mainPosition,
  selectedCampOptions: state.form.selectedCampOptions,
  programType: state.form.programType,
  programLengthInWeeks: state.form.programLengthInWeeks,
  programLengthInDays: state.form.programLengthInDays,
  forcedRefundable: state.form.forcedRefundable,
  refundable: state.form.refundable,
  selectedConcentrationOptions: state.form.selectedConcentrationOptions,
  locked: state.form.locked,
});

const mapDispatchToProps = (dispatch) => ({
  addProductToCart: (product) => dispatch(addProductToCart(product)),
  removeProductFromCart: (id) => dispatch(removeProductFromCart(id)),
  replaceProductInCart: (product, id) =>
    dispatch(replaceProductInCart(product, id)),
  selectCampOption: (key, value) => dispatch(selectCampOption(key, value)),
  deselectCampOption: (key) => dispatch(deselectCampOption(key)),
  resetSelectedOptions: () => dispatch(resetSelectedOptions()),
  resetOptions: async () => {
    await dispatch(resetBundleOptions());
    //await dispatch(resetConcentrationOptions());
  },
  setProgramType: (pt) => dispatch(setProgramType(pt)),
  setProgramPeriod: (value) => dispatch(setProgramPeriod(value)),
  setCartRefundable: (value) => {
    dispatch(setRefundable(value));
    dispatch(setCartRefundable(value));
  },
  setBoarding: (value) => dispatch(setBoarding(value)),
  selectConcentrationOption: (key, value) =>
    dispatch(selectConcentrationOption(key, value)),
  deselectConcentrationOption: (key) =>
    dispatch(deselectConcentrationOption(key)),
  setLocked: (value) => dispatch(setLocked(value)),
  setConcentrationDataLength: (value) =>
    dispatch(setConcentrationDataLength(value)),
  setSkipConcentrations: (value) => dispatch(setSkipConcentrations(value)),
});

StepTwo.propTypes = {
  initialDate: PropTypes.string,
  initialSecondaryGroup: PropTypes.string,
  sport: PropTypes.bool.isRequired,
  businessType: PropTypes.bool.isRequired,
  boarding: PropTypes.bool.isRequired,
  gender: PropTypes.string.isRequired,
  age: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired,
  mainPosition: PropTypes.string.isRequired,
  selectedCampOptions: PropTypes.object.isRequired,
  programType: PropTypes.string,
  programLengthInWeeks: PropTypes.number,
  programLengthInDays: PropTypes.number,
  forcedRefundable: PropTypes.bool,
  addProductToCart: PropTypes.func.isRequired,
  removeProductFromCart: PropTypes.func.isRequired,
  replaceProductInCart: PropTypes.func.isRequired,
  selectCampOption: PropTypes.func.isRequired,
  deselectCampOption: PropTypes.func.isRequired,
  resetSelectedOptions: PropTypes.func.isRequired,
  resetOptions: PropTypes.func.isRequired,
  setProgramType: PropTypes.func.isRequired,
  setProgramPeriod: PropTypes.func.isRequired,
  defaultRefundable: PropTypes.bool,
  setCartRefundable: PropTypes.func.isRequired,
  refundable: PropTypes.bool,
  setBoarding: PropTypes.func.isRequired,
  selectConcentrationOption: PropTypes.func.isRequired,
  deselectConcentrationOption: PropTypes.func.isRequired,
  selectedConcentrationOptions: PropTypes.object,
  locked: PropTypes.bool,
  setLocked: PropTypes.func.isRequired,
  setConcentrationDataLength: PropTypes.func.isRequired,
  setSkipConcentrations: PropTypes.func.isRequired,
};

StepTwo.displayName = 'StepTwo';

export default connect(mapStateToProps, mapDispatchToProps)(StepTwo);
